import React, { useRef } from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import NavMobilStyle from '../styles/NavMobilStyle';

export default function NavMobil({ pageContent, location }) {
  const menuToggleRef = useRef(null);

  const handleLinkClick = () => {
    if (menuToggleRef.current) {
      menuToggleRef.current.click();
    }
  };

  return (
    <NavMobilStyle>
      <section className="top-nav">
      <Link to="/" className="logo-link">
          <div>
            <ul className="logo-ul">
              <li>
                Muriel Consigny P<span style={{ opacity: '0' }}>aysages</span>
              </li>

              <li>
                M<span style={{ opacity: '0' }}>uriel</span> C
                <span style={{ opacity: '0' }}>onsigny</span> Paysages
              </li>
            </ul>
          </div>
        </Link>
        <input id="menu-toggle" type="checkbox" ref={menuToggleRef} />
        <label className="menu-button-container" htmlFor="menu-toggle">
          <div>
            <FontAwesomeIcon icon={faBars} size="2x" />
          </div>
        </label>
        <ul className="menu">
          <div className="menu-list">
            <Link to="/realisations" onClick={handleLinkClick}> Réalisations </Link>
            <Link to="/etudes" onClick={handleLinkClick}> Études </Link>
            <Link to="/actualites" onClick={handleLinkClick}> Actualités </Link>
            <Link to="/contact" onClick={handleLinkClick}>Contact</Link>
          <Link to="/colophon" onClick={handleLinkClick}>Colophon</Link>
          <Link to="/cv" onClick={handleLinkClick}>CV</Link>
          <Link to="/biographie" onClick={handleLinkClick}>Biographie</Link>
          </div>
        </ul>
      </section>
    </NavMobilStyle>
  );
}
